// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"83ae9ced","592":"6de868db"}[chunkId] + ".chunk.js";
};